var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 12.069,
    viewBox: "0 0 12.5 12.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17805",
    "data-name": "Group 17805",
    transform: "translate(-1167.375 -433.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24391",
    "data-name": "Path 24391",
    d: "M7.5,12.5h5.625",
    transform: "translate(1166.125 432.5)",
    fill: "none",
    stroke: "#185cff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24392",
    "data-name": "Path 24392",
    d: "M10.313,2.188a1.326,1.326,0,0,1,1.875,1.875L4.375,11.875l-2.5.625L2.5,10Z",
    transform: "translate(1166.125 432.5)",
    fill: "none",
    stroke: "#185cff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportEdit);
export default __webpack_public_path__ + "static/media/report-edit.0a284d0b522fd444d290ca3132be04f9.svg";
export { ForwardRef as ReactComponent };